import React from "react"

import Layout2 from "../components/layout2"
import SEO from "../components/seo"

import InternLinks from "../components/internlinks";
import { FaCheck } from 'react-icons/fa';

const IndexPage = () => (
  <Layout2>
     <SEO title="Oral B PRO 2 2000 White" description="Recension av Oral B Pro 2" keywords={[`Oral B`, `Vita tänder`, `Eltandborste`, `Tandblekning hemma`, `Oral B Pro 2 2000`]}/>
     <section className="section-produkter">
       <article>
       <div className="prod-text">
          <h1>Oral B PRO 2 2000</h1>
         </div>
      </article>
      <article class="right">
        <img src="../oral-b-pro-2-2000.webp" alt="PRO 2 2000 White Sensi UltraThin Eltandborste"/>
        <aside>
          <h3 class="erbj-pris">599:-</h3>
          <h2>Pro 2 2000 White o Pro 2 2200S Blue</h2>
          <p class="prod-beskrivning">
          </p>
          <a href="https://ion.lyko.com/t/t?a=1117786221&as=1480987224&t=2&tk=1&url=https://lyko.com/sv/oral-b/oral-b-pro-2-2000-white-sensi-ultrathin-eltandborste" target="_blank" rel="noopener noreferrer" class="btn btn-warning btn-width">Beställ här</a>
          <ul>
             <li><FaCheck className="li-icon" />Extra mjukt runt borsthuvud</li>
             <li><FaCheck className="li-icon" />2 minuters timer</li>
             <li><FaCheck className="li-icon" />Uppladdningsbart batterie</li>
          </ul>
        </aside>
        <div className="prod-text"><h5>Pro 2 2000 och Pro 2200S</h5>
         <p>Oral-B PRO 2 2000 White Sensi UltraThin med ett runt borsthuvud och tar 
          bort upp till 100 % mer plack än en vanlig, manuell tandborste för att bidra till ett hälsosammare
          tandkött och att ta bort ytliga missfärgningar på tänderna. Dessutom hjälper tandborsten dig att skydda det 
          ömtåliga tandköttet med hjälp av den patenterade trycksensortekniken som drar ner på borstningshastigheten 
          och gör dig uppmärksam på att borsta skonsammare om du borstar för hårt.</p>
          <p>Pro 2200S kommer i blå färg</p></div>
      </article>

       </section>
       {/* <section className="section-cards">
    <main>
    <h2 class="rubrik-tandblekning">Bästa tandblekningen hemma</h2>
       <Card />
       </main>
  </section> */}

  <section className="section-cards card-height">
  <main>
      <h2 class="internal-rubrik">Bästa tandblekningen hemma</h2>
    <InternLinks />
    </main>
  </section>
  </Layout2>
)

export default IndexPage
